import e from "../../hooks/useResizeObserver.js";
import t from "../../utils/classNames.js";
import { forwardRef as n, useImperativeHandle as r, useLayoutEffect as i, useRef as a } from "react";
import { jsx as o } from "react/jsx-runtime";
//#region src/components/applicationLayout/ApplicationLayoutHeader.tsx
var s = n((n, s) => {
	let { className: c, children: l, ...u } = n, d = a(null), [f, , { blockSize: p }] = e();
	r(s, () => d.current, [d]), i(() => {
		let e = d.current?.parentNode;
		if (!(e instanceof HTMLElement)) return;
		let t = f.current, n = t?.firstElementChild instanceof HTMLElement && Number.parseFloat(window.getComputedStyle(t.firstElementChild).borderBottomWidth) || 0, r = p ? Math.max(0, p - n) : 0;
		r ? e.style.setProperty("--ApplicationLayoutHeaderHeight", `${r}px`) : e.style.removeProperty("--ApplicationLayoutHeaderHeight");
	}, [
		p,
		l,
		f
	]), i(() => {
		let e = d.current?.parentNode;
		return () => {
			e instanceof HTMLElement && e.style.removeProperty("--ApplicationLayoutHeaderHeight");
		};
	}, []);
	let m = t("ApplicationLayoutHeader", c);
	return /* @__PURE__ */ o("div", {
		ref: d,
		...u,
		className: m,
		id: "ApplicationLayoutHeader",
		children: /* @__PURE__ */ o("div", {
			ref: f,
			className: "ApplicationLayoutHeaderContent",
			children: l
		})
	});
});
//#endregion
export { s as default };

//# sourceMappingURL=ApplicationLayoutHeader.js.map